export enum FIRMWARE_FEATURES {
    BluetoothListAutoSyncSupport = "BluetoothListAutoSyncSupport",
    GeofenceListAutoSyncSupport = "GeofenceListAutoSyncSupport",
    MainConfigurationAutoSyncSupport = "MainConfigurationAutoSyncSupport",
    OneWireListAutoSyncSupport = "OneWireListAutoSyncSupport"
}
